// extracted by mini-css-extract-plugin
module.exports = {"h80":"styles--h80--2zOtX","circle":"styles--circle--3rU1d"};